import { render, staticRenderFns } from "./Unavailable_.vue?vue&type=template&id=4c056816&scoped=true&"
import script from "./Unavailable_.vue?vue&type=script&lang=js&"
export * from "./Unavailable_.vue?vue&type=script&lang=js&"
import style0 from "./Unavailable_.vue?vue&type=style&index=0&id=4c056816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c056816",
  null
  
)

export default component.exports